<div class="mobilemenu" [ngClass]="{ 'mobilemenu--open': isOpen }">
  <div class="mobilemenu__backdrop" (click)="menuCategorias.close(2)"></div>
  <div class="mobilemenu__body">
    <div class="px-3 flex align-items-center" style="height: 50px">
      <i
        class="fa-regular fa-square-chevron-left fa-2x me-2"
        style="cursor: pointer"
        (click)="close()"
      ></i>
      <div class="text-truncate text-center col me-5" style="color: #000">
        {{ titulo | titlecase }}
      </div>
    </div>

    <div class="mobilemenu__content">
      <ul>
        <li
          class="mb-3 flex justify-content-between"
          *ngFor="let item of nivel2"
        >
          <div
            *ngIf="item.items.length > 0"
            class="text-truncate"
            (click)="menuCategorias.open(3, item)"
          >
            {{ item.label | titlecase }}
          </div>
          <div
            *ngIf="item.items.length === 0"
            class="text-truncate"
            (click)="seleccionar()"
            [routerLink]="item.url"
            [queryParams]="{ filter_MARCA: item.url.at(-1), tiendaOficial: 1 }"
          >
            {{ item.label | titlecase }}
          </div>
          <div
            *ngIf="item.items.length > 0"
            (click)="menuCategorias.open(3, item)"
          >
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </li>
        <li
          *ngIf="titulo !== 'TIENDAS OFICIALES'"
          class="mt-3 flex justify-content-center"
        >
          <a
            href="#"
            class="urlAction"
            (click)="seleccionar()"
            [routerLink]="url"
            [title]="titulo"
            >Ver Todo {{ titulo | titlecase }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</div>

<app-nivel3 [items]="nivel2" (seleccionado)="seleccionar()"></app-nivel3>
